import type { EmailCaptureElementProps } from './EmailCapture.types';

export function EmailCaptureElement(props: EmailCaptureElementProps) {
  const { children, attributes } = props;

  return (
    <div {...attributes} className="flex flex-col h-auto relative">
      {children}
    </div>
  );
}
